import { render } from "./FullWidthImageSliderPreview.vue?vue&type=template&id=c2c51626&scoped=true"
import script from "./FullWidthImageSliderPreview.vue?vue&type=script&lang=js"
export * from "./FullWidthImageSliderPreview.vue?vue&type=script&lang=js"

import "./FullWidthImageSliderPreview.vue?vue&type=style&index=0&id=c2c51626&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2c51626"]])

export default __exports__